export interface ContactHistory {
  emails: string[];
  phones: string[];
  deliveryOption?: "email" | "whatsapp" | "email_whatsapp";
}

const STORAGE_KEY = "tarot_recent_contacts_v1";
const MAX_RECENT = 5;

export const emptyContactHistory: ContactHistory = { emails: [], phones: [] };

export function readContactHistory(): ContactHistory {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    if (!value || !Array.isArray(value.emails) || !Array.isArray(value.phones)) {
      return emptyContactHistory;
    }
    return {
      emails: value.emails.filter((item: unknown): item is string => typeof item === "string").slice(0, MAX_RECENT),
      phones: value.phones.filter((item: unknown): item is string => typeof item === "string").slice(0, MAX_RECENT),
      deliveryOption: ["email", "whatsapp", "email_whatsapp"].includes(value.deliveryOption)
        ? value.deliveryOption
        : undefined,
    };
  } catch {
    return emptyContactHistory;
  }
}

export function rememberContacts(
  history: ContactHistory,
  email?: string,
  phone?: string,
  deliveryOption?: ContactHistory["deliveryOption"],
): ContactHistory {
  const normalizedEmail = email?.trim().toLowerCase();
  const normalizedPhone = phone?.trim();
  const next = {
    deliveryOption: deliveryOption ?? history.deliveryOption,
    emails: normalizedEmail
      ? [normalizedEmail, ...history.emails.filter((item) => item.toLowerCase() !== normalizedEmail)].slice(0, MAX_RECENT)
      : history.emails,
    phones: normalizedPhone
      ? [normalizedPhone, ...history.phones.filter((item) => item !== normalizedPhone)].slice(0, MAX_RECENT)
      : history.phones,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Browser storage may be unavailable; the current form can still proceed.
  }
  return next;
}
